import { safeUrl } from '@/utils/safeUrl'

const ALLOWED_TAGS = new Set([
  'p', 'br', 'b', 'strong', 'i', 'em', 'u', 's', 'del', 'sub', 'sup',
  'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'hr',
  'ul', 'ol', 'li', 'dl', 'dt', 'dd',
  'table', 'thead', 'tbody', 'tfoot', 'tr', 'th', 'td', 'caption', 'colgroup', 'col',
  'blockquote', 'pre', 'code', 'kbd', 'var', 'samp',
  'a', 'img', 'figure', 'figcaption',
  'div', 'span', 'small', 'mark', 'abbr', 'details', 'summary',
])

const ALLOWED_ATTRS = new Set([
  'href', 'src', 'alt', 'title', 'class', 'id', 'style',
  'width', 'height', 'colspan', 'rowspan', 'target', 'rel', 'open',
])

/** Whitelist HTML sanitizer — порт sanitizeHtmlWhitelist() из PHP. */
export function sanitizeHtmlWhitelist(html: string): string {
  if (!html) return ''
  const tempDiv = document.createElement('div')
  tempDiv.innerHTML = html

  const walk = (node: Node) => {
    const children = Array.from(node.childNodes)
    for (const child of children) {
      if (child.nodeType === Node.TEXT_NODE) continue
      if (child.nodeType !== Node.ELEMENT_NODE) {
        child.remove()
        continue
      }
      const el = child as HTMLElement
      const tag = el.tagName.toLowerCase()
      if (!ALLOWED_TAGS.has(tag)) {
        while (el.firstChild) node.insertBefore(el.firstChild, el)
        el.remove()
        continue
      }
      Array.from(el.attributes).forEach((attr) => {
        const name = attr.name.toLowerCase()
        if (!ALLOWED_ATTRS.has(name) || name.startsWith('on')) {
          el.removeAttribute(attr.name)
        }
      })
      if (tag === 'a') {
        el.setAttribute('href', safeUrl(el.getAttribute('href') || ''))
        el.setAttribute('target', '_blank')
        el.setAttribute('rel', 'noopener noreferrer')
      }
      if (tag === 'img') {
        el.setAttribute('src', safeUrl(el.getAttribute('src') || ''))
        el.style.maxWidth = '100%'
        el.style.borderRadius = '4px'
      }
      walk(el)
    }
  }
  walk(tempDiv)
  return tempDiv.innerHTML
}

/** Порт normalizeInstructionLists() из PHP. */
export function normalizeInstructionLists(root: HTMLElement | null) {
  if (!root) return
  root.querySelectorAll('li').forEach((li) => {
    Array.from(li.childNodes).forEach((node) => {
      if (node.nodeType === Node.TEXT_NODE && !node.textContent?.trim()) {
        li.removeChild(node)
      }
    })
    Array.from(li.children).forEach((child) => {
      if (child.tagName === 'P') {
        if (!child.textContent?.trim()) {
          child.remove()
          return
        }
        while (child.firstChild) {
          li.insertBefore(child.firstChild, child)
        }
        child.remove()
      }
    })
  })
}

export function renderInstructionHtml(content: string): string {
  const sanitized = sanitizeHtmlWhitelist(content)
  const wrap = document.createElement('div')
  wrap.innerHTML = sanitized
  normalizeInstructionLists(wrap)
  return wrap.innerHTML
}
